import type {
  SearchResultJobV5,
  SourcrRecruiterExternalReference,
} from '@seek/chalice-types';

import { useSourcrOnSRPJobCardFeatureFlag } from 'src/store/featureFlags/hooks';

export const getExternalReference = (
  job: SearchResultJobV5 | undefined,
  sourceSystem: string,
  type: string,
) => {
  if (job) {
    return job.externalReferences?.find(
      (reference) =>
        reference.sourceSystem === sourceSystem && reference.type === type,
    );
  }
};

export const useSourcrRecruiterForTracking = (
  job: SearchResultJobV5 | undefined,
) => {
  const sourcrOnSRPJobCard = useSourcrOnSRPJobCardFeatureFlag();

  const externalReference = getExternalReference(job, 'sourcr', 'recruiter');

  if (externalReference && sourcrOnSRPJobCard) {
    const sourcrRecruiter =
      externalReference as SourcrRecruiterExternalReference;

    if (
      sourcrRecruiter.metadata?.name &&
      sourcrRecruiter.metadata?.assets?.profilePhotoUrl
    ) {
      // We don't render the Sourcr info if the name or profile photo is missing so don't return anything
      return sourcrRecruiter;
    }
  }
};
